<template lang="pug">
section.totalizadores
    h3 {{ $t('mensagens.home.totalizadores.titulo') }}

    .totalizadores__linha
        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-mapa
            .informacoes
                h1.totalizadores__titulo {{ formatters.formatNumberUs(totalizadores.territoriosCadastrados, 3) }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.territoriosCadastrados') }}
        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-territorio-monitorado
            .informacoes
                h1.totalizadores__titulo {{ formatters.formatNumberUs(totalizadores.territoriosMonitorados, 3) }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.territoriosMonitorados') }}

        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-relevo
            .informacoes
                h1.totalizadores__titulo {{ totalizadores.areasFormatada }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.hectaresEmMonitoramento') }}

    .totalizadores__linha
        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-user
            .informacoes
                h1.totalizadores__titulo {{ formatters.formatNumberUs(totalizadores.proprietarios, 3) }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.pessoasCadastradas') }}

        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-grafico
            .informacoes
                h1.totalizadores__titulo {{ formatters.formatNumberUs(totalizadores.diagnosticos, 3) }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.diagnosticosSocioambientais') }}

        .lyra__cartao(v-loading='carregando')
            .icone
                i.lyra-icon.lyra-laudos
            .informacoes
                h1.totalizadores__titulo {{ formatters.formatNumberUs(totalizadores.laudos, 3) }}
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.laudosEmitidos') }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';

export default {
    name: 'Totalizadores',

    data() {
        return {
            formatters,
            totalizadores: {},
            carregando: true
        };
    },

    methods: {
        async buscarTotalizadores() {
            this.carregando = true;
            try {
                const { data } = await UtilsService.buscarTotalizadores();
                this.totalizadores = data;
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.home.totalizadores.erro')
                });
            } finally {
                this.carregando = false;
            }
        }
    },

    mounted() {
        this.buscarTotalizadores();
    }
};
</script>

<style lang="scss" scoped>
.totalizadores {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }
}

.totalizadores__linha {
    flex-grow: 1;
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.totalizadores__linha:last-child {
    margin-bottom: 0;
}

.lyra__cartao {
    display: grid;
    grid-template-columns: 1fr 2fr;
    flex: 1 1 30%;
    align-items: center;

    .icone {
        justify-content: center;
        align-items: center;
        padding: 20%;
        font-size: 50px;
        .lyra-icon {
            display: flex;
        }
        .lyra-icon.lyra-mapa::before {
            width: 38px !important;
        }
        .lyra-icon.lyra-relevo::before {
            width: 40px !important;
        }
        .lyra-icon.lyra-user::before {
            height: 38px !important;
        }
        .lyra-laudos.lyra-user::before {
            height: 36px !important;
        }
        .lyra-icon::before {
            content: '';
            width: 32px !important;
            height: 33.5px !important;
            background-color: var(--primary) !important;
        }
    }
}

.informacoes {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.totalizadores__titulo {
    font-size: 35px;
    text-align: center;
    color: var(--primary);
}

.totalizadores__subtitulo {
    width: 100px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: var(--primary);
}

@media (max-height: 710px) {
    .totalizadores__titulo {
        font-size: 20px;
    }

    .totalizadores__subtitulo {
        font-size: 14px;
    }
}
</style>
